require('angular-ui-mask');
require('./datePickingModal.scss');

const controller = require('./datePickingModalCtrl').default;
const template = require('./datePickingModal.html');

const deps = ['ui.mask'];

module.exports = angular
  .module('bench.ui.datePickingModal', deps)
  .component('blAccountsDatePickingModal', {
    bindings: {
      noticeMessage: '@',
      selectionMessage: '@',
      maxDateAllowed: '<',
      minDateAllowed: '<',
      minValidDate: '<',
      onConfirm: '&?',
    },
    template,
    controller,
    controllerAs: 'vm',
  });
